<template>
  <svg viewBox="-50 -20 340 340" aria-hidden="true">
    <g clip-path="url(#clip0_1401_86274)">
      <mask
        id="mask0_1401_86274"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="240"
        height="300">
        <path d="M240 0H0V300H240V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1401_86274)">
        <path d="M180 240H60V120H180V240Z" fill="currentColor" opacity="0.5" />
        <path
          d="M180 60H60V240H180V60ZM240 300H0V0H240V300Z"
          fill="currentColor"
          fill-rule="evenodd"
          clip-rule="evenodd" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1401_86274"><rect width="240" height="300" fill="white" /></clipPath>
    </defs>
  </svg>
</template>
